import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";

import YouTubeThumbnail from "./YoutubeThumbnail";
import LoadingIndicator from "../components/LoadingIndicator";

import { getDiscourseByType } from "../../../services/database/database_service";
import {setDiscourseData} from "../../../store/discourseSlice";
import { useLanguage } from "../../../services/localization/LanguageContex";



function DiscourseSubScreenOne() {
  const { t } = useLanguage();
  const dispatch = useDispatch();
  const data = useSelector((state)=>state.discourse.discourseData);

  const {type} = useParams();// This can be dynamic based on your requirements
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    async function fetchPhrases() {
      try {
        const response = await getDiscourseByType(type);
        if (response.documents) {
          dispatch(setDiscourseData(response.documents));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    fetchPhrases();
  }, []);

  return (
    <Box sx={{ 
      px: { xs: 3, sm: 6, md: 6 }, 
      pt: 2 , pb:6}}>
      {/* <Typography variant="h4" gutterBottom align="center" sx={{ mb: 3 }}>
        {t(type)}
      </Typography> */}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          
          <LoadingIndicator/>
          {/* <CircularProgress /> */}

        </Box>
      ) : error ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="error">
            {error}
          </Typography>
        </Box>
      ) : data.length === 0 ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            No data found under "{type}" yet.
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Please check back later as we continue to add more.
          </Typography>
        </Box>
      ) : (
<>
      <Typography variant="h4" gutterBottom align="center" sx={{ mb: 3 }}>
        {t(type)}
      </Typography>
        <Grid container spacing={4}>
          {data.map((dataItem) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={dataItem.$id}>
              <Link
                to={`/home/discourse/${encodeURIComponent(type)}/${encodeURIComponent(dataItem.discourseTitle)}`}
                style={{ textDecoration: "none" }}
              >
                <Card
                  sx={{
                    bgcolor: "transparent",
                    boxShadow: "none",
                  }}
                >
                  <CardContent sx={{ p: 0 }}>
                    <YouTubeThumbnail
                      videoUrl={dataItem.discourseUrl}
                      altText={dataItem.discourseTitle}
                    />
                    <Typography
                      variant="subtitle1"
                      noWrap
                      sx={{ mt: 1, px: 1 }}
                    >
                      {t(dataItem.discourseTitle)}
                    </Typography>
                  </CardContent>
                </Card>
              </Link>
            </Grid>
          ))}
        </Grid>

        </>
      )}
    </Box>
  );
}

export default DiscourseSubScreenOne;
